// extracted by mini-css-extract-plugin
export default {"container":"header_container__mTu+Y","box_container":"header_box_container__7ajcd","text_box":"header_text_box__fqhMv","cv":"header_cv__gVnrC","contact":"header_contact__2z4e7"};